import { render, staticRenderFns } from "./areasList.vue?vue&type=template&id=476427dc&scoped=true&"
import script from "./areasList.vue?vue&type=script&lang=js&"
export * from "./areasList.vue?vue&type=script&lang=js&"
import style0 from "./areasList.vue?vue&type=style&index=0&id=476427dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476427dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardSubtitle,VCardText})
